/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { ReservationState } from '../state/ReservationState'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'

class ReservationsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReservationState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccommodationInvoiceEvent.fetchOne:
        return state.mergeModel(payload.reservation)

      case AccommodationInvoiceEvent.createStart:
        return state.mergeModel(payload)

      default:
        return state
    }
  }
}

export default new ReservationsStore()
